import React, { Component } from 'react';
import axios from 'axios';
import {FormattedHTMLMessage} from 'react-intl';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js'
import CustomSpinner from './CustomSpinner.js'
import FlowProgressBar from './FlowProgressBar';
import Section from './Section.js'

require(`../assets/${process.env.PAGE}/css/components/EmailVerification.css`);

class EmailVerification extends Component {

    constructor(props){
        super(props);
        this.state = {
            verified: false
        }
    }

    componentDidMount(){
        this.props.setIsLoading(true);
        const ROOT_URL = process.env.API_URL;
        let jwt = sessionStorage.getItem('jwtUrl');

        var config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
            }
        };

        if(sessionStorage.getItem('jwtUrl')){

            axios.get(`${ROOT_URL}/leads/email_verification/${jwt}`, config)
            .then(res => {
                this.props.throwNextStep();
            }).catch(error => {
                this.props.setIsLoading(false);
                switch(error.response.status) {
                    case 401:
                        this.setState({
                            verified: false,
                        });
                        break;
                    default:
                        this.setState({
                            verified: false,
                        });
                        break;
                }
            });
        } else{
            this.props.setIsLoading(false);
        }
    }

    render() {
        return (
            <Section className="intro_form">
                <div className="row">
                    <div className="pd-content-left col-md-5 col-lg-5 text-center" >
                        <div className="header-img" >
                            <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo_blanco_montemar.png`)} />
                        </div>
                        <div className="header-message">
                            <FormattedHTMLMessage id="app.step_email_verification" description="Email Verification info" />
                        </div>
                    </div>
                    <div className="pd-content-right col-sm-12 col-md-7 col-lg-7">
                        {this.props.isLoading && <CustomSpinner message='Estamos analizando su solicitud. Por favor espere...' /> }
                        <FlowProgressBar />
                        <div className="pvc-container text-center">
                            <h4><b>Estamos terminando de procesar tu Préstamo Aprobado. Cuando esté listo, recibirás un enlace en tu correo electrónico para continuar.</b></h4>
                        </div>
                    </div>
                </div>
            </Section>
        );
    }
}

EmailVerification = TopScrolleable(EmailVerification);

EmailVerification = withAuthControl(EmailVerification);

export default EmailVerification;



/** WEBPACK FOOTER **
 ** ./src/components/EmailVerification.js
 **/